export default __webpack_public_path__ + "static/te_small-image_3-ca50e89bcdbd6366b103487ea19a879d.png";